import { styled, Button, Input, useTheme } from '@teko/ui';
import React from 'react';

const StyledStepper = styled.div(({ color }) => `
    display: flex;
    align-items: center;
    border-radius: 0.25rem;
    border: 1px solid ${color};
    align-items: center;
    overflow: hidden;
    background: #fff;
    justify-content: space-between;
  `);
const Value = styled.div(({ color }) => `
    flex: 1;
    color: ${color};
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  `);
const StyledButton = styled(Button)(({ color }) => `
    line-height: 1;
    color: ${color};
    font-size: 1rem;
    border: none;
    padding: 0;
    align-self: stretch;
    padding: 0.5rem;
    border-radius: 0;
    --button-icon-color: ${color};
`);
const Sign = styled.span`
  display: inline-block;
  width: 1rem;
  height: 1rem;
`;
const StyledInput = styled(Input)(({ color }) => `
  padding: 0;
  color: ${color};
  width: 2rem;
  border: none;
  text-align: center;
`);
const handleFocus = (event) => event.target.select();
const BuildPcNumberStepper = ({
  value,
  minimumValue,
  maximumValue,
  stepValue = 1,
  onIncrease,
  onDecrease,
  setValue,
  className,
  showDeleteIcon = true,
  variant = "primary",
  primaryColor
}) => {
  var _a, _b;
  const theme = useTheme();
  const color = variant === "primary" ? ((_a = theme.brand) == null ? void 0 : _a.primary) || primaryColor : theme.colors.dark;
  const borderColor = variant === "primary" ? ((_b = theme.brand) == null ? void 0 : _b.primary) || primaryColor : theme.colors.gray300;
  return /* @__PURE__ */ React.createElement(StyledStepper, {
    className,
    color: borderColor
  }, /* @__PURE__ */ React.createElement(StyledButton, {
    color,
    outline: true,
    onClick: onDecrease,
    disabled: minimumValue ? value - stepValue < minimumValue : false,
    icon: value === 1 && showDeleteIcon ? {
      name: "trash",
      size: 16
    } : null
  }, (!showDeleteIcon || value > 1 || !value) && /* @__PURE__ */ React.createElement(Sign, null, "-")), setValue ? /* @__PURE__ */ React.createElement(StyledInput, {
    type: "number",
    onChange: (e) => setValue(parseInt(e.target.value)),
    value,
    color,
    onFocus: handleFocus
  }) : /* @__PURE__ */ React.createElement(Value, {
    color
  }, value), /* @__PURE__ */ React.createElement(StyledButton, {
    color,
    variant,
    outline: true,
    onClick: onIncrease,
    disabled: maximumValue ? value + stepValue > maximumValue : false
  }, /* @__PURE__ */ React.createElement(Sign, null, "+")));
};

export { BuildPcNumberStepper };
